import React from 'react';

//MAIN (web/Mobile)
const MainPage = React.lazy(() => import('./views/MainPage')); //05, 06, 10, 11,12, 13 -Main 페이지

//DESIGNS
const Design = React.lazy(() => import('./views/design/Design')); //15, 16, 17, 18, 19 Designs 카텍고리/스타일 리스트
const DesignDetailView = React.lazy(() => import('./views/design/DesignDetailView')); //20, 21, 22,
const DesignShop = React.lazy(() => import('./views/design/DesignShop')); //23
const DesignPattern = React.lazy(() => import('./views/design/DesignPattern')); //24

//회원가입/로그인
const LoginPage = React.lazy(() => import('./views/auth/LoginPage')); //26
const SignUpPage = React.lazy(() => import('./views/auth/SignUpPage')); //27
const InputInformation = React.lazy(() => import('./views/auth/InputInformation')); //28
const EmailVerifyPage = React.lazy(() => import('./views/auth/EmailVerifyPage')); //29
const ForgetPassword = React.lazy(() => import('./views/auth/ForgetPassword')); //31
const ViewTerms = React.lazy(() => import('./views/auth/ViewTerms')); //33~37
const ViewTermsOld = React.lazy(() => import('./views/auth/ViewTermsOld')); //33~37

//서비스 소개
const BankIntro = React.lazy(() => import('./views/intro/BankIntro')); //39
const AgentIntro = React.lazy(() => import('./views/intro/AgentIntro')); //40
const FaqIntro = React.lazy(() => import('./views/intro/FaqIntro')); //41
const ViewFaq = React.lazy(() => import('./views/intro/ViewFaq')); //42

// 회원가이드
const LicenseGuide = React.lazy(() => import('./views/guide/LicenseGuide')); //44  디자인 라이센스 가이드
const SellerGuide = React.lazy(() => import('./views/guide/SellerGuide')); //45  판매가이드
const BuyerGuide = React.lazy(() => import('./views/guide/BuyerGuide')); //46, 47, 48  구매가이드
const VipGuide = React.lazy(() => import('./views/guide/VipGuide')); //49  VipSeller 란

//Trend
const Trends = React.lazy(() => import('./views/trend/Trends')); //51
const ViewTrend = React.lazy(() => import('./views/trend/ViewTrend')); //52

//AI 디자인 생성
const AIGenerate = React.lazy(() => import('./views/ai_generate/AIGenerate'));
const AIGenerateIntro = React.lazy(() => import('./views/ai_generate/AIGenerateIntro'));
const AIGenerateDetail = React.lazy(() => import('./views/ai_generate/AIGenerateDetail'));

//AI 디자인 크레딧 구매
const AIGenerateCreditPurchase = React.lazy(() => import('./views/ai_purchase/AIGenerateCreditPurchase'));

//Mypage->기본정보
const MyPage = React.lazy(() => import('./views/mypage/MyPage')); //나의 정보
const BasicInfo = React.lazy(() => import('./views/mypage/basic/BasicInfo')); //54  회원정보
const SignOut = React.lazy(() => import('./views/mypage/basic/SignOut')); //55  회원탈퇴
const ReqSeller = React.lazy(() => import('./views/mypage/basic/ReqSeller')); //56  판매계정 신청
const AlermList = React.lazy(() => import('./views/mypage/basic/AlermList')); //57  알림함
const SvcCenter = React.lazy(() => import('./views/mypage/basic/SvcCenter')); //58  고객센터
const ViewAnswer = React.lazy(() => import('./views/mypage/basic/ViewAnswer')); //59  회신보기
const WriteQuestion = React.lazy(() => import('./views/mypage/basic/WriteQuestion')); //60  문의 작성하기

//Mypage->구매정보
const PurchaseList = React.lazy(() => import('./views/mypage/purchase/PurchaseList')); //61  구매내역, 63  환불내역
const BasketList = React.lazy(() => import('./views/mypage/purchase/BasketList')); //65  장바구니
const AnonymouseBasketList = React.lazy(() => import('./views/mypage/purchase/AnonymouseBasketList')); //65  장바구니
const FavoriList = React.lazy(() => import('./views/mypage/purchase/FavoriList')); //64  관심상품
const DesignerList = React.lazy(() => import('./views/mypage/purchase/DesignerList')); //66 관심디자이너

//Mypage->AI생성정보
const GenerateResultList = React.lazy(() => import('./views/mypage/ai_generate/GenerateResultList'));
const GeneratePurchaseList = React.lazy(() => import('./views/mypage/ai_generate/GeneratePurchaseList'));
const GenerateBasketList = React.lazy(() => import('./views/mypage/ai_generate/GenerateBasketList'));


//MYPage -> Credit 구매 정보 (구매, 환불)
const CreditPurchaseList = React.lazy(()=> import('./views/mypage/credit/CreditPurchaseList'));
const CreditRefundList = React.lazy(()=> import('./views/mypage/credit/CreditRefundList'));


//Mypage->판매정보
const GoodsList = React.lazy(() => import('./views/mypage/sales/GoodsList')); //67,68  상품목록
const EditGood = React.lazy(() => import('./views/mypage/sales/EditGood')); //69  상품 수정/등록
const SellList = React.lazy(() => import('./views/mypage/sales/SellList')); //70  판매내역, 71  환불내역
const Withdrawal = React.lazy(() => import('./views/mypage/sales/Withdrawal')); //72  출금신청, 73  출금신청
const Calculate = React.lazy(() => import('./views/mypage/sales/Calculate')); //74  정산내역

//Mypage->저작권 서비스
const AgencyList = React.lazy(() => import('./views/mypage/AgencyList')); //75  저작권 서비스
const AgentReq = React.lazy(() => import('./views/mypage/AgentReq')); //76  저작권 출원 요청

//Mypage->VipSeller 서비스
const ViqReqlist = React.lazy(() => import('./views/mypage/ViqReqlist')); //77    Vip 신청

//채용
const EmployView = React.lazy(() => import('./views/employ/Employ'));

//Contact
const NoticeList = React.lazy(() => import('./views/contact/NoticeList')); //79   공지사항
const ViewNotice = React.lazy(() => import('./views/contact/ViewNotice')); //80   공지사항 보기
const EventList = React.lazy(() => import('./views/contact/EventList')); //82  이벤트 리스트
const ViewEvent = React.lazy(() => import('./views/contact/ViewEvent')); //83  이벤트 보기
const IntroCompany = React.lazy(() => import('./views/contact/IntroCompany')); //85  회사소개
const CustomReq = React.lazy(() => import('./views/contact/CustomReq')); //87    제휴문의 작성
const Maintenance = React.lazy(() => import('./views/error/Maintenance')); //91  서비스 점검안내
const Page404 = React.lazy(() => import('./views/error/Page404')); //92
const Page500 = React.lazy(() => import('./views/error/Page500')); //93

const SelfAuthentication = React.lazy(() => import('./views/mypage/basic/SelfAuthentication')); //본인인증 페이지

export const mainroutes = [
  { path: '/main', name: 'mainpage', component: MainPage },
  { path: '/design/:category/:style', name: 'design', component: Design, exact: true },
  { path: '/design/detail/item/:id', name: 'designdetail', component: DesignDetailView },
  { path: '/designer/shop/:id', name: 'designshop', component: DesignShop },
  { path: '/design/pattern', name: 'designpattern', component: DesignPattern },

  { path: '/auth', name: 'auth', component: LoginPage, exact: true },
  { path: '/auth/login', name: 'login', component: LoginPage },
  { path: '/auth/signup', name: 'signup', component: SignUpPage },
  { path: '/auth/editaccount', name: 'editaccount', component: InputInformation },
  { path: '/auth/email/:type', name: 'email', component: EmailVerifyPage },
  { path: '/auth/forgetpsw', name: 'forgetpasword', component: ForgetPassword },
  { path: '/viewterm/:type', name: 'viewterm', component: ViewTerms },
  { path: '/viewtermold/:type', name: 'viewtermold', component: ViewTermsOld },

  { path: '/employ', name: 'employ', component: EmployView },

  { path: '/intro', name: 'intro', component: BankIntro, exact: true },
  { path: '/intro/agent', name: 'agent', component: AgentIntro },
  { path: '/intro/faq', name: 'faq', component: FaqIntro },
  { path: '/intro/faqview/:id', name: 'faqview', component: ViewFaq },

  { path: '/guide', name: 'licenseguide', component: LicenseGuide, exact: true },
  { path: '/guide/seller', name: 'sellerguide', component: SellerGuide },
  { path: '/guide/buyer', name: 'buyerguide', component: BuyerGuide },
  { path: '/guide/vip', name: 'vipguide', component: VipGuide },

  { path: '/trend', name: 'trends', component: Trends, exact: true },
  { path: '/trend/viewtrend/:id', name: 'viewtrend', component: ViewTrend },

  { path: '/notices', name: 'notices', component: NoticeList, exact: true },
  { path: '/notices/view/:id', name: 'viewnotice', component: ViewNotice },

  { path: '/events', name: 'events', component: EventList, exact: true },
  { path: '/events/view/:id', name: 'viewevent', component: ViewEvent },

  { path: '/mypage', name: 'mypage', component: MyPage },
  { path: '/selfauth', name: 'selfauth', component: SelfAuthentication },

  { path: '/aboutus', name: 'aboutus', component: IntroCompany },
  { path: '/writereq', name: 'writereq', component: CustomReq },
  { path: '/maintenance', name: 'maintenance', component: Maintenance },
  { path: '/err404', name: 'err404', component: Page404 },
  { path: '/err500', name: 'err500', component: Page500 },
  { path: '/anonymous/basket', name: 'basket', component: AnonymouseBasketList },

  { path: '/generate/service', name: 'generate', component: AIGenerate },
  { path: '/generate/intro/:type', name: 'generateintro', component: AIGenerateIntro },
  { path: '/generate/result/detail/:id', name: 'generatedetail', component: AIGenerateDetail},
  { path: '/generate/purchase/credit' , name:'generatecreditpurchase', component: AIGenerateCreditPurchase}

];

export const mypageroutes = [
  { path: '/mypage/basic', name: 'basicinf', component: BasicInfo, exact: true },
  { path: '/mypage/basic/signout', name: 'signout', component: SignOut },
  { path: '/mypage/basic/reqseller', name: 'reqseller', component: ReqSeller },
  { path: '/mypage/basic/alerms', name: 'alerm', component: AlermList },
  { path: '/mypage/basic/svccenter', name: 'svccenter', component: SvcCenter },
  { path: '/mypage/basic/viewanswer/:id', name: 'viewanswer', component: ViewAnswer },
  { path: '/mypage/basic/writequs', name: 'writequs', component: WriteQuestion },

  { path: '/mypage/purchase', name: 'purchase', component: PurchaseList, exact: true },
  { path: '/mypage/purchase/basket', name: 'basket', component: BasketList },
  { path: '/mypage/purchase/favori', name: 'favori', component: FavoriList },
  { path: '/mypage/purchase/designer', name: 'designer', component: DesignerList },

  { path: '/mypage/generate/result', name: 'generateresult', component: GenerateResultList },
  { path: '/mypage/generate/purchase', name: 'generatepurchase', component: GeneratePurchaseList },
  { path: '/mypage/generate/basket', name: 'generatebasket', component: GenerateBasketList },

  // 크레딧 구매내역 리스트
  { path :'/mypage/credit/purchasecredit/:type' , name:'purchasecredit', component :CreditPurchaseList},
  { path :'/mypage/credit/refundcredit' , name:'purchasecredit', component :CreditRefundList},

  { path: '/mypage/sales', name: 'goods', component: GoodsList, exact: true },
  { path: '/mypage/sales/editgood/:idx', name: 'editgood', component: EditGood },
  { path: '/mypage/sales/sell', name: 'sell', component: SellList },
  { path: '/mypage/sales/withdraw', name: 'withdraw', component: Withdrawal },
  { path: '/mypage/sales/calculate', name: 'calculate', component: Calculate },

  { path: '/mypage/agency', name: 'agency', component: AgencyList },
  { path: '/mypage/agentreq', name: 'agentreq', component: AgentReq },
  { path: '/mypage/vipreq', name: 'vipreq', component: ViqReqlist },
];
// export default routes;